import { render, staticRenderFns } from "./HotNewGoods.vue?vue&type=template&id=ec89c4f0&scoped=true"
import script from "./HotNewGoods.vue?vue&type=script&lang=js"
export * from "./HotNewGoods.vue?vue&type=script&lang=js"
import style0 from "./HotNewGoods.vue?vue&type=style&index=0&id=ec89c4f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec89c4f0",
  null
  
)

export default component.exports